import { useIntl } from 'react-intl';
import LogoStrip from '@/Components/Marketing/LogoStrip';
import Section from '@/Components/Marketing/Section';

/**
 * The partner strip under the hero: who Synex Cloud is a member of and who
 * uses it. Logos only. From lg its top padding clears the 120px of hero
 * screenshot that reaches into it (HERO_OVERLAP in Hero.jsx) plus its own
 * spacing.
 */
export default function Partners() {
    const { formatMessage } = useIntl();

    const groups = [
        {
            label: formatMessage({ id: 'site.home.logos.member' }),
            logos: [
                { src: '/images/partners/cirpass.webp', alt: 'CIRPASS²', width: 277, height: 132, className: 'h-11' },
                {
                    src: '/images/partners/battery-pass-ready.webp',
                    alt: 'Battery Pass Ready',
                    width: 455,
                    height: 228,
                    // The artwork fills the middle ~45% of a white canvas that
                    // carries crop marks in its corners: drawn larger, with the
                    // edges clipped, it matches the others optically.
                    className: 'h-[76px] -my-4 [clip-path:inset(16%_4%)]',
                },
            ],
        },
        {
            label: formatMessage({ id: 'site.home.logos.trusted' }),
            logos: [
                { src: '/images/partners/elhim-iskra.webp', alt: 'Elhim Iskra', width: 300, height: 114, className: 'h-10' },
                { src: '/images/partners/vigalex.webp', alt: 'Vigalex', width: 334, height: 96, className: 'h-8' },
            ],
        },
    ];

    return (
        <Section tone="surface" className="border-t border-mk-line pb-16 pt-16 sm:pb-20 sm:pt-20 lg:pt-[200px]">
            <LogoStrip groups={groups} />
        </Section>
    );
}
